const QueueType = {
  Area: 'area',
  Line: 'line',
  Group: 'group',
}

export default QueueType;
